"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerFavouriteInstruction = exports.makeOfferInstruction = exports.makeFixedPriceInstruction = exports.cancelOfferInstruction = exports.cancelFixedPriceInstruction = exports.buyFixedPriceInstruction = exports.acceptOfferInstruction = void 0;
const borsh_1 = require("borsh");
const web3_js_1 = require("@solana/web3.js");
class acceptOfferInstruction {
    constructor() {
        this.tag = 2;
    }
    serialize() {
        return (0, borsh_1.serialize)(acceptOfferInstruction.schema, this);
    }
    getInstruction(programId, offerAccount, offerBeneficiary, nameAccount, escrowTokenAccount, destinationTokenAccount, feeAccount, splTokenProgram, nameServiceProgram) {
        const data = Buffer.from(this.serialize());
        let keys = [];
        keys.push({
            pubkey: offerAccount,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: offerBeneficiary,
            isSigner: true,
            isWritable: false,
        });
        keys.push({
            pubkey: nameAccount,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: escrowTokenAccount,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: destinationTokenAccount,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: feeAccount,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: splTokenProgram,
            isSigner: false,
            isWritable: false,
        });
        keys.push({
            pubkey: nameServiceProgram,
            isSigner: false,
            isWritable: false,
        });
        return new web3_js_1.TransactionInstruction({
            keys,
            programId,
            data,
        });
    }
}
exports.acceptOfferInstruction = acceptOfferInstruction;
acceptOfferInstruction.schema = new Map([
    [
        acceptOfferInstruction,
        {
            kind: "struct",
            fields: [["tag", "u8"]],
        },
    ],
]);
class buyFixedPriceInstruction {
    constructor() {
        this.tag = 5;
    }
    serialize() {
        return (0, borsh_1.serialize)(buyFixedPriceInstruction.schema, this);
    }
    getInstruction(programId, fixedPriceOffer, buyer, nameAccount, tokenDestination, tokenSource, feeAccount, splTokenProgram, nameServiceProgram) {
        const data = Buffer.from(this.serialize());
        let keys = [];
        keys.push({
            pubkey: fixedPriceOffer,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: buyer,
            isSigner: true,
            isWritable: false,
        });
        keys.push({
            pubkey: nameAccount,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: tokenDestination,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: tokenSource,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: feeAccount,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: splTokenProgram,
            isSigner: false,
            isWritable: false,
        });
        keys.push({
            pubkey: nameServiceProgram,
            isSigner: false,
            isWritable: false,
        });
        return new web3_js_1.TransactionInstruction({
            keys,
            programId,
            data,
        });
    }
}
exports.buyFixedPriceInstruction = buyFixedPriceInstruction;
buyFixedPriceInstruction.schema = new Map([
    [
        buyFixedPriceInstruction,
        {
            kind: "struct",
            fields: [["tag", "u8"]],
        },
    ],
]);
class cancelFixedPriceInstruction {
    constructor() {
        this.tag = 4;
    }
    serialize() {
        return (0, borsh_1.serialize)(cancelFixedPriceInstruction.schema, this);
    }
    getInstruction(programId, fixedPriceOffer, fixedPriceOfferOwner, nameAccount, nameServiceProgram, systemProgram) {
        const data = Buffer.from(this.serialize());
        let keys = [];
        keys.push({
            pubkey: fixedPriceOffer,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: fixedPriceOfferOwner,
            isSigner: true,
            isWritable: false,
        });
        keys.push({
            pubkey: nameAccount,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: nameServiceProgram,
            isSigner: false,
            isWritable: false,
        });
        keys.push({
            pubkey: systemProgram,
            isSigner: false,
            isWritable: false,
        });
        return new web3_js_1.TransactionInstruction({
            keys,
            programId,
            data,
        });
    }
}
exports.cancelFixedPriceInstruction = cancelFixedPriceInstruction;
cancelFixedPriceInstruction.schema = new Map([
    [
        cancelFixedPriceInstruction,
        {
            kind: "struct",
            fields: [["tag", "u8"]],
        },
    ],
]);
class cancelOfferInstruction {
    constructor() {
        this.tag = 1;
    }
    serialize() {
        return (0, borsh_1.serialize)(cancelOfferInstruction.schema, this);
    }
    getInstruction(programId, owner, tokenDestination, escrowAccount, offerAccount, splTokenProgram) {
        const data = Buffer.from(this.serialize());
        let keys = [];
        keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false,
        });
        keys.push({
            pubkey: tokenDestination,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: escrowAccount,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: offerAccount,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: splTokenProgram,
            isSigner: false,
            isWritable: false,
        });
        return new web3_js_1.TransactionInstruction({
            keys,
            programId,
            data,
        });
    }
}
exports.cancelOfferInstruction = cancelOfferInstruction;
cancelOfferInstruction.schema = new Map([
    [
        cancelOfferInstruction,
        {
            kind: "struct",
            fields: [["tag", "u8"]],
        },
    ],
]);
class makeFixedPriceInstruction {
    constructor(obj) {
        this.tag = 3;
        this.amount = obj.amount;
        this.quoteMint = obj.quoteMint;
    }
    serialize() {
        return (0, borsh_1.serialize)(makeFixedPriceInstruction.schema, this);
    }
    getInstruction(programId, fixedPriceOffer, fixedPriceOfferOwner, nameAccount, tokenDestination, nameServiceProgram, systemProgram) {
        const data = Buffer.from(this.serialize());
        let keys = [];
        keys.push({
            pubkey: fixedPriceOffer,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: fixedPriceOfferOwner,
            isSigner: true,
            isWritable: true,
        });
        keys.push({
            pubkey: nameAccount,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: tokenDestination,
            isSigner: false,
            isWritable: false,
        });
        keys.push({
            pubkey: nameServiceProgram,
            isSigner: false,
            isWritable: false,
        });
        keys.push({
            pubkey: systemProgram,
            isSigner: false,
            isWritable: false,
        });
        return new web3_js_1.TransactionInstruction({
            keys,
            programId,
            data,
        });
    }
}
exports.makeFixedPriceInstruction = makeFixedPriceInstruction;
makeFixedPriceInstruction.schema = new Map([
    [
        makeFixedPriceInstruction,
        {
            kind: "struct",
            fields: [
                ["tag", "u8"],
                ["amount", "u64"],
                ["quoteMint", [32]],
            ],
        },
    ],
]);
class makeOfferInstruction {
    constructor(obj) {
        this.tag = 0;
        this.amount = obj.amount;
        this.nameAccount = obj.nameAccount;
    }
    serialize() {
        return (0, borsh_1.serialize)(makeOfferInstruction.schema, this);
    }
    getInstruction(programId, owner, quoteMint, tokenSource, escrowTokenAccount, offerAccount, systemProgram, rentAccount, splTokenProgram) {
        const data = Buffer.from(this.serialize());
        let keys = [];
        keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: true,
        });
        keys.push({
            pubkey: quoteMint,
            isSigner: false,
            isWritable: false,
        });
        keys.push({
            pubkey: tokenSource,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: escrowTokenAccount,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: offerAccount,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: systemProgram,
            isSigner: false,
            isWritable: false,
        });
        keys.push({
            pubkey: rentAccount,
            isSigner: false,
            isWritable: false,
        });
        keys.push({
            pubkey: splTokenProgram,
            isSigner: false,
            isWritable: false,
        });
        return new web3_js_1.TransactionInstruction({
            keys,
            programId,
            data,
        });
    }
}
exports.makeOfferInstruction = makeOfferInstruction;
makeOfferInstruction.schema = new Map([
    [
        makeOfferInstruction,
        {
            kind: "struct",
            fields: [
                ["tag", "u8"],
                ["amount", "u64"],
                ["nameAccount", [32]],
            ],
        },
    ],
]);
class registerFavouriteInstruction {
    constructor() {
        this.tag = 6;
    }
    serialize() {
        return (0, borsh_1.serialize)(registerFavouriteInstruction.schema, this);
    }
    getInstruction(programId, nameAccount, favouriteAccount, owner, systemProgram) {
        const data = Buffer.from(this.serialize());
        let keys = [];
        keys.push({
            pubkey: nameAccount,
            isSigner: false,
            isWritable: false,
        });
        keys.push({
            pubkey: favouriteAccount,
            isSigner: false,
            isWritable: true,
        });
        keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: true,
        });
        keys.push({
            pubkey: systemProgram,
            isSigner: false,
            isWritable: false,
        });
        return new web3_js_1.TransactionInstruction({
            keys,
            programId,
            data,
        });
    }
}
exports.registerFavouriteInstruction = registerFavouriteInstruction;
registerFavouriteInstruction.schema = new Map([
    [
        registerFavouriteInstruction,
        {
            kind: "struct",
            fields: [["tag", "u8"]],
        },
    ],
]);
//# sourceMappingURL=raw_instructions.js.map